import React from 'react';
const stats = [{
  value: '+500',
  label: 'allenatori',
  color: 'text-[#FF6B00]'
}, {
  value: '6+6',
  label: 'Volumi + Bonus',
  color: 'text-[#FF6B00]'
}, {
  value: '4.9/5',
  label: 'calificazione ⭐',
  color: 'text-[#FF6B00]'
}, {
  value: '🇮🇹',
  label: 'Italia',
  color: 'text-[#0A0A0A]'
}];
const testimonials = [{
  quote: 'Ho organizzato tutta la stagione in una sola serata. Ora ogni allenamento ha un obiettivo chiaro.',
  name: 'Marco R.',
  role: 'Allenatore Giovanile'
}, {
  quote: 'I miei giocatori migliorano più velocemente perché finalmente seguono una progressione logica.',
  name: 'Andrea P.',
  role: 'Allenatore U15'
}, {
  quote: 'Non passo più ore su YouTube a cercare esercizi. Apro Basket Pronto e ho già tutto.',
  name: 'Luca T.',
  role: 'Istruttore MiniBasket'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white py-12 px-4 border-b border-[#E5E5EA]" data-id="element-179">
      <div className="max-w-5xl mx-auto" data-id="element-180">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-181">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-182">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-183">
                {s.value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-184">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-185">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-186">
              <div className="text-[#FFD700] text-lg mb-3" data-id="element-187">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-188">
                "{t.quote}"
              </p>
              <div data-id="element-189">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-190">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-191">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}